import { createListing, createUser } from '../../util/test-data';
import SectionProposal from './SectionProposal';

const noop = () => null;

const listing = createListing(
  'application-listing',
  {
    title: 'Graafinen suunnittelija – brändi-ilmeen kokonaisuudistus, logistiikka-ala',
    publicData: {
      priceEstimate: '3 000 – 5 000 €',
      projectDuration: 'project',
      projectTier: 'senior',
      projectUrgency: 'within_a_month',
      projectProblem: '<p>Nykyinen brändi-ilme on vanhentunut eikä erotu kilpailijoista.</p>',
      descriptionText:
        '<p>Etsimme graafista suunnittelijaa uudistamaan logon, värimaailman ja typografian.</p><ul><li>Logo ja sen variaatiot</li><li>Brändiohjeisto</li></ul>',
    },
  },
  {
    author: createUser('application-listing-author', {
      profile: { displayName: 'Logistiikka Oy', abbreviatedName: 'LO', publicData: {} },
    }),
  }
);

export const Default = {
  component: SectionProposal,
  props: {
    listing,
    listingDeleted: false,
    bestFit: '<p>Olen tehnyt vastaavia brändiuudistuksia yli kymmenen vuoden ajan.</p>',
    similarWork: '<p>Esimerkkejä aiemmista töistä löytyy portfoliostani.</p>',
    questions: '<p>Onko nykyinen logo tarkoitus säilyttää osana uudistusta?</p>',
    portfolioWorks: [],
    loadingPortfolioWorks: false,
    onManageDisableScrolling: noop,
  },
  group: 'transaction',
};

// Without a skill level the job posting shows three detail tiles instead of four
export const NoSkillLevel = {
  component: SectionProposal,
  props: {
    ...Default.props,
    listing: {
      ...listing,
      attributes: {
        ...listing.attributes,
        publicData: {
          ...listing.attributes.publicData,
          priceEstimate: '10 000 € +',
          projectTier: undefined,
        },
      },
    },
  },
  group: 'transaction',
};

export const ListingDeleted = {
  component: SectionProposal,
  props: {
    ...Default.props,
    listingDeleted: true,
  },
  group: 'transaction',
};
